import Component from './Sensor.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconSensor', Component);
  },
};
